import { TipoActividad } from "../enums/TipoActividad";
import { TipoRecorrido } from "../enums/TipoRecorrido";

class Ruta {

    idRuta: number;

    tipoActividad: TipoActividad;

    tipoRecorrido: TipoRecorrido;

    nombre: string;

    descripcion: string;

    track: any;

    constructor(idRuta: number, tipoActividad: TipoActividad, tipoRecorrido: TipoRecorrido, nombre: string, descripcion: string) {
        this.idRuta = idRuta;
        this.tipoActividad = tipoActividad;
        this.tipoRecorrido = tipoRecorrido;
        this.nombre = nombre;
        this.descripcion = descripcion;
    }

}

export default Ruta;